<template>
  <div id="Landing">
    <b-container fluid>
      <b-row>
        <b-col xl="5" lg="12" md="12" sm="12" class="welcome">
          <h2>Welcome</h2>
          <h1>{{name}}</h1>
          <p v-if="credit != ' $ -   '">As of February 15, 2021, you have <span>{{credit}} in ticket credit</span> plus a 25% bonus in the amount of {{bonus}} for concessions and merchandise.</p>
          <div class="repInfo">
            <b-row>
              <b-col>
                <img v-if="rep === 'Kenzie Dill'" src="@/assets/images/Kenzie-Dill.png" alt="rep" />
                <img v-if="rep === 'Emilee Bell'" src="@/assets/images/Emilee-Bell.png" alt="rep" />
                <img v-if="rep === 'Matt Gianoni'" src="@/assets/images/Matt-Gianoni.png" alt="rep" />
                <img v-if="rep === 'Megan Paul'" src="@/assets/images/Megan-Paul.png" alt="rep" />
                <img v-if="rep === 'Jeff Tanzer'" src="@/assets/images/Jeff-Tanzer.png" alt="rep" />
                <img v-if="rep === 'Dan Newhart'" src="@/assets/images/Dan-Newhart.png" alt="rep" />
                <p v-if="rep === 'Your Rays Representative Ticket Sales'" class="repName noRep">{{rep}}</p>
                <p v-else class="repName">Rays Representative {{rep}}</p>
                <p v-if="rep === 'Your Rays Representative Ticket Sales'" class="repContact noRep">{{repPhone}}  &bull; <a :href="`mailto:` + repEmail">{{repEmail}}</a></p>
                <p v-else class="repContact">{{repPhone}}  &bull; <a :href="`mailto:` + repEmail">{{repEmail}}</a></p>
              </b-col>
            </b-row>
          </div>
          <div class="countDown">
            <b-row>
              <b-col>
                <p>Countdown to Opening Day</p>
                <CountDown startDate="December 12, 2020 23:59:59" endDate="April 1, 2021 16:10:00" />
              </b-col>
            </b-row>
            <!-- <b-row class="renewBtn">
              <b-col>
                <a v-scroll-to="'#Renew'">Renew Now</a>
              </b-col>
            </b-row> -->
          </div>
        </b-col>
        <b-col xl="7" class="laptop">
          <b-button v-b-modal.modal-1>
            <img src="@/assets/images/laptop.png" alt="Laptop" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="modal-1" size="xl" hide-footer hide-header>
      <div class="videoWrapper">
        <vueVimeoPlayer :video-id="videoID" :options="options" @ready="onReady" ref="player"></vueVimeoPlayer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";
import CountDown from "@/components/global/Countdown";
export default {
  name: "Landing",
  components: {
    CountDown,
    vueVimeoPlayer
  },
  data() {
    return {
      videoID: "492640894",
      options: {
        background: true,
        muted: false
      },
      playerReady: false,
      name: null,
      credit: null,
      bonus: null,
      rep: null,
      repEmail: null,
      repPhone: null
    };
  },
  methods: {
		onReady() {
      this.playerReady = true
      this.$refs.player.unmute()
    }
  },
  created(){
    let userInfo = this.$store.state.global.userInfo;
    window.console.log('userInfo', userInfo);
    this.name = userInfo.financialFormatName
    this.credit = userInfo.totalCredit
    this.bonus = userInfo.totalBonus
    this.rep = userInfo.repName
    this.repEmail = userInfo.repEmail
    this.repPhone = userInfo.repPhone
  }
}
</script>

<style lang="scss" scoped>
  #Landing {
    background-image: url("~@/assets/images/bg-main.png");
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    position: relative;
    padding: 200px 0 300px 0;
    @media only screen and (max-width: $xl) {
      background-size: cover;
    }
    @media only screen and (max-width: $sm) {
      padding: 200px 0 100px 0;
    }
    .welcome {
      padding-left: 7%;
      h1 {
        font-family: 'UniversLTStd-UltraCn';
        color: $dark-blue;
        font-size: 90px;
        text-transform: uppercase;
        line-height: 90px;
        @media only screen and (max-width: $md) {
          font-size: 70px;
          line-height: 70px;
        }
      }
      h2 {
        font-family: 'UniversLTStd-UltraCn';
        color: $dark-blue;
        font-size: 48px;
        text-transform: uppercase;
        line-height: 48px;
      }
      p {
        font-family: 'UniversLTStd';
        color: $dark-blue;
        font-size: 16px;
        line-height: 22px;
        span {
          font-family: 'UniversLTStd-Bold';
        }
      }
    }
    .repInfo {
      margin-top: 25px;
      img {
        float: left;
      }
      p {
        margin-left: 110px;
        &.noRep {
          margin-left: 0;
        }
        &.repName {
          font-family: 'UniversLTStd-Bold';
          font-size: 18px;
          color: $aqua;
          margin-top: 15px;
        }
        &.repContact {
          font-family: 'UniversLTStd-Bold';
          font-size: 18px;
          color: #000;
          a {
            font-family: 'UniversLTStd-Bold';
            font-size: 18px;
            color: #000;
            text-decoration: underline;
          }
        }
      }
    }
    .countDown {
      margin-top: 25px;
      p {
        font-family: 'UniversLTStd-Bold';
        font-size: 18px;
        color: $aqua;
        line-height: 18px;
      }
      .renewBtn {
        margin-top: 30px;
        a {
          font-family: 'UniversLTStd';
          font-size: 14px;
          color: #fff;
          background-color: $dark-blue;
          border-radius: 25px;
          padding: 15px 40px;
          text-transform: uppercase;
          cursor: pointer;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
    .laptop {
      @media only screen and (max-width: $xl) {
        margin-top: 100px;
      }
      img {
        width: 100%;
      }
    } 
  }
</style>
<style lang="scss">
  body {
    padding-right: 0px !important;
  }
  .videoWrapper {
    width: 100%;
    height: 800px;
    position: absolute;
    left: 0;
    right: 0;
    iframe {
      width: 100%;
      height: 800px;
    }
  }
  .btn-secondary {
    background-color: transparent !important;
    border-color: transparent !important;
    width: 100%;
    &:focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
    &:visited {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }
  #modal-1 {
    .modal-content {
    background-color: transparent !important;
    }
    .modal-body {
      background-color: transparent !important;
    }
  }
  
  #modal-2 {
    .modal-content {
      font-family: 'UniversLTStd' !important;
      background-color: #fff !important;
      p {
        margin: 15px 0 !important;
        color: $dark-blue !important;
        a {
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .renewBtn {
        margin: 35px 0;
        a {
          font-family: 'UniversLTStd-Bold';
          font-size: 16px;
          color: #000;
          background-color: $yellow;
          border-radius: 25px;
          padding: 15px 40px;
          text-transform: uppercase;
          cursor: pointer;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }

  #modal-3 {
    .modal-content {
      font-family: 'UniversLTStd' !important;
      background-color: #fff !important;
      p {
        margin: 15px 0 !important;
        color: $dark-blue !important;
        a {
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .renewBtn {
        margin: 35px 0;
        a {
          font-family: 'UniversLTStd-Bold';
          font-size: 16px;
          color: #000;
          background-color: $yellow;
          border-radius: 25px;
          padding: 15px 40px;
          text-transform: uppercase;
          cursor: pointer;
          &:hover {
            text-decoration: none;
          }
        }
        button {
          font-family: 'UniversLTStd-Bold';
          font-size: 16px;
          color: #000;
          background-color: $yellow !important;
          border-radius: 25px;
          padding: 13px 40px;
          text-transform: uppercase;
          width: 200px;
          cursor: pointer;
          &:hover {
            text-decoration: none;
          }
        }
        #selectInvoiceErr {
          color: #da3e3e;
          font-size: 14px;
          margin-top: 10px;
          margin-left: 5px;
          display: none;
        }
      }
      .invoiceOptions {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        @media only screen and (max-width: $md) {
          flex-direction: column;
        }
        .option {
          margin: 0 20px;
          label {
            @media only screen and (max-width: $lg) {
              font-size: 14px;
            }
          }
          input {
            margin-left: 5px;
          }
        }
      }
    }
  }
</style>